"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxSaga = require("redux-saga");

var _utilities = require("./utilities");

var RefreshTokensTimeout =
/*#__PURE__*/
function () {
  function RefreshTokensTimeout(options) {
    (0, _classCallCheck2.default)(this, RefreshTokensTimeout);
    this.options = (0, _objectSpread2.default)({}, RefreshTokensTimeout.options, options);
    this.timerId = null;
  }

  (0, _createClass2.default)(RefreshTokensTimeout, [{
    key: "calcTimeoutValue",
    value: function calcTimeoutValue(tokens) {
      var expiration = (0, _utilities.findMinExpiration)(tokens);
      var timeoutValue = (0, _utilities.calcTimeout)(expiration, this.options.requestDurationEstimate);
      return timeoutValue;
    }
  }, {
    key: "clearTimeout",
    value: function clearTimeout() {
      if (this.timerId) {
        window.clearTimeout(this.timerId);
        this.timerId = null;
      }
    }
  }, {
    key: "makeTimeoutChannel",
    value: function makeTimeoutChannel(timeout) {
      var _this = this;

      var timeoutChannel = (0, _reduxSaga.eventChannel)(function (emitter) {
        _this.timerId = window.setTimeout(function () {
          // emitter callback must be provided
          // with an argument
          emitter(timeout);
        }, timeout); // return unsubscribe method

        return _this.clearTimeout;
      });
      return timeoutChannel;
    }
    /**
     * validate tokens expiration with 'requestDurationEstimate'
     * and 'minRequiredExpiration' in count
     * @param {Object} tokens
     * @returns {Boolean}
     */

  }, {
    key: "validateExpiration",
    value: function validateExpiration(tokens) {
      var timeoutValue = this.calcTimeoutValue(tokens);

      try {
        (0, _utilities.validateTimeoutValue)({
          timeoutValue: timeoutValue,
          options: this.options,
          tokens: tokens
        });
        return true;
      } catch (error) {
        return false;
      }
    }
    /**
     * 1. reset any previous timeout
     * 2. find token with the smallest expiration value
     * 3. calculate timeout value
     * 4. set timeout for refreshing tokens
     * @param {Object} [tokens={}]
     */

  }, {
    key: "setTimeout",
    value: function setTimeout(tokens) {
      this.clearTimeout();
      var timeoutValue = this.calcTimeoutValue(tokens);
      (0, _utilities.validateTimeoutValue)({
        timeoutValue: timeoutValue,
        options: this.options,
        tokens: tokens
      });
      var timeoutChannel = this.makeTimeoutChannel(timeoutValue);
      return timeoutChannel;
    }
  }]);
  return RefreshTokensTimeout;
}();

exports.default = RefreshTokensTimeout;
(0, _defineProperty2.default)(RefreshTokensTimeout, "options", {
  // refresh tokens 0.5s before token expires
  requestDurationEstimate: 500,
  // 0.5s
  minRequiredExpiration: 1000 * 60 // 1m

});